import RequestAbstract from "../abstract";

export default class PublicCommissionTypes extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = 'api/public-commission-types';
    }

}
